import { handleErrorWithSentry } from "@sentry/sveltekit";
import * as Sentry from '@sentry/sveltekit';
import {
  PUBLIC_SENTRY_RELEASE,
  PUBLIC_SENTRY_DSN,
  PUBLIC_ENVIRONMENT,
} from '$env/static/public'

Sentry.init({
  dsn: PUBLIC_SENTRY_DSN,
  enableLogs: true,
  environment: PUBLIC_ENVIRONMENT,
  attachStacktrace: true,
  dist: 'web',
  enabled: PUBLIC_ENVIRONMENT !== 'development',
  release: PUBLIC_SENTRY_RELEASE,
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // If you don't want to use Session Replay, just remove the line below:
  integrations: [
    // replayIntegration()
  ],

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/sveltekit/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});
Sentry.getGlobalScope().setTag('app', 'web')

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
